import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const ReticleIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <span className={className} data-testid={testId}>
        ⊙
    </span>
);

export default ReticleIcon;
